import { PluginKey } from 'prosemirror-state';
var BSControlKey = new PluginKey('basicControl');
export { BSControlKey };
//# sourceMappingURL=const.js.map